import React from 'react'
import { Layout } from '../layouts/Layout';
import { TakeAwayData } from '../componen/TakeAwayData'

export const TakeAwayPages = () => {
  return (
    <Layout>
      <TakeAwayData />
    </Layout>
  )
}